import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Contact } from './types';

import { Box } from '@mui/material';

import { ConfirmationDialog } from 'components/shared';
import ActionCard from 'components/shared/ActionCard';

import ContactDialog, { ProcessedContact } from './ContactDialog';

type Props = Contact & {
  onContactSaved: (contact: ProcessedContact) => void;
  onDeleteContact: (id: number) => void;
};

export default function ContactCard(props: Props) {
  const { t } = useTranslation('common');
  const { onContactSaved, onDeleteContact, ...contact } = props;
  const { firstName, lastName, phoneNumber, emailAddress, remark } = contact;
  const [showContactDialog, setShowContactDialog] = useState(false);
  const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] =
    useState(false);

  return (
    <>
      <ActionCard
        className="contact"
        sx={{ mb: 2 }}
        title={`${firstName} ${lastName}`}
        onEditClick={() => setShowContactDialog(true)}
        onDeleteClick={() => setShowDeleteConfirmationDialog(true)}
      >
        <Box width="200px" flexShrink={0}>
          <div>
            <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
          </div>
          <div>
            <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
          </div>
        </Box>
        <Box width="150px">{remark || ''}</Box>
      </ActionCard>
      {showContactDialog && (
        <ContactDialog
          contact={contact}
          onSave={onContactSaved}
          onHidden={() => setShowContactDialog(false)}
        />
      )}

      {showDeleteConfirmationDialog && (
        <ConfirmationDialog
          handleAction={(isConfirmed) => {
            setShowDeleteConfirmationDialog(false);
            if (isConfirmed) {
              onDeleteContact(contact.id);
            }
          }}
          cancelBtnText={t('no')}
          confirmBtnText={t('yes')}
          title={t('adminPortal.settings.contacts.deleteContactDialog.title', {
            name: `${firstName} ${lastName}`
          })}
          type="warning"
        >
          <p>{t('adminPortal.settings.contacts.deleteContactDialog.body')}</p>
        </ConfirmationDialog>
      )}
    </>
  );
}
